// Native dialogs provide focus containment and Escape; restore focus on every close.
// Keep the guards at module scope because an entry point can be bootstrapped
// more than once while switching between the desktop and Web surfaces.
const boundTriggers = new WeakSet<HTMLElement>();
const boundDialogs = new WeakSet<HTMLDialogElement>();
const boundCloseButtons = new WeakSet<HTMLElement>();

function restoreFocus(target: HTMLElement | null): void {
  if (!target || !target.isConnected || target.hasAttribute('disabled')) return;
  if (target.closest('.hidden') || target.closest('[aria-hidden="true"]')) return;
  target.focus({ preventScroll: true });
}

export function bindSiteDialogs(): void {

  document.querySelectorAll<HTMLElement>('[data-open-dialog]').forEach(trigger => {
    if (boundTriggers.has(trigger)) return;
    boundTriggers.add(trigger);
    trigger.addEventListener('click', () => {
      const dialog = document.getElementById(trigger.dataset.openDialog!) as HTMLDialogElement;
      if (dialog && !dialog.open) {
        if (!boundDialogs.has(dialog)) {
          boundDialogs.add(dialog);
          dialog.addEventListener('click', event => {
            if (event.target === dialog) dialog.close();
          });
        }
        const opener = trigger;
        dialog.showModal();
        dialog.addEventListener('close', () => restoreFocus(opener), { once: true });
        window.requestAnimationFrame(() => {
          if (!dialog.open) return;
          const firstInput = dialog.querySelector<HTMLElement>(
            'input:not([disabled]), select:not([disabled]), textarea:not([disabled])',
          );
          const firstAction = dialog.querySelector<HTMLElement>(
            'button:not([disabled]):not([data-close-dialog]), a[href]',
          );
          (firstInput || firstAction || dialog.querySelector<HTMLElement>('[data-close-dialog]'))?.focus({
            preventScroll: true,
          });
        });
      }
    });
  });
  document.querySelectorAll<HTMLElement>('[data-close-dialog]').forEach(button => {
    if (boundCloseButtons.has(button)) return;
    boundCloseButtons.add(button);
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });
}
